import { render, staticRenderFns } from "./FileDragDetector.vue?vue&type=template&id=9b984582&scoped=true"
import script from "./FileDragDetector.vue?vue&type=script&lang=js"
export * from "./FileDragDetector.vue?vue&type=script&lang=js"
import style0 from "./FileDragDetector.vue?vue&type=style&index=0&id=9b984582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b984582",
  null
  
)

export default component.exports